import {PropsWithChildren, useEffect} from 'react';
import {useDrawerContext} from '../../context/drawer-context';
import {createPortal} from 'react-dom';
import {ContentWrapper} from './content-wrapper.styled';

export function DrawerPanel({children}: PropsWithChildren) {
	const {setWithPanel, isPanelOpen, panelRef} = useDrawerContext();

	useEffect(() => {
		setWithPanel(true);

		return () => {
			setWithPanel(false);
		};
	}, []);

	if (!isPanelOpen || !panelRef || !panelRef.current) {
		return null;
	}

	return createPortal(<ContentWrapper>{children}</ContentWrapper>, panelRef.current);
}
